import { type ISurveyItem } from './AdminSurvey'

export interface ICreatedBy {
  createdBy: string
  createdByUsername: string
  createdOn: string
}

export interface IOwnedBy {
  ownedBy: string
  ownedByUsername: string
}

export interface IModifiedBy {
  modifiedBy: string
  modifiedByUsername: string
  modifiedOn: string
}
export interface DataPermissions {
  title: string[]
}

export enum PermissionEnum {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  CREATE = 'CREATE',
  ARCHIVE = 'ARCHIVE'
}
export interface DataObject<T> {
  actions: string[]
  data: T
  dataPermissions: Record<keyof[T], PermissionEnum[]>
  permissions: PermissionEnum[]
  views: DataView[]
}

export interface DataView {
  type: string
  id: string
  model: string
  path: string
}

export interface DataTypeEnum {
  LINK: 'Link'
  TEXT: 'Text'
  CHIP: 'Chip'
  DATE: 'Date'
}

export interface DataHeader {
  field: string
  headerName: string
  alwaysShow: boolean
  shown: boolean
  type: DataTypeEnum
}

export interface DataKey {
  alwaysShow: boolean
  field: string
  headerName: string
  shown: boolean
  type: string
}

export interface IPagination {
  numPages: number
  pageNumber: number
  pageSize: number
  totalResults: number
};

export interface DataObjectList<T> {
  actions: string[]
  data: Array<DataObject<T>>
  header: DataHeader
  keys: DataKey[]
  permissions: PermissionEnum[]
  pagination: IPagination
}

export type KeyStatName =
  | 'Average'
  | 'Median'
  | 'Mode'
  | 'Top 2'
  | 'Bottom 2'
  | 'StandardDeviation'
